<template>
  <div style="height: 100%">
    <b-row>
      <b-col>
        <iq-card>
          <b-row class="p-2 pl-4 pt-4">
            <FormulateForm
              name="createTemplate"
              @submit="submitHandler"
              #default="{ isLoading }"
              v-model="formValues"
              class="w-100"
            >
              <b-col class="d-flex justify-content-between">
                <div>
                  <FormulateInput
                    id="name"
                    name="name"
                    type="text"
                    :value="formValues.name"
                    @keyup="changed = true"
                    style="width: 500px"
                    input-class="form-control"
                  />
                </div>
                <div class="d-flex">
                   <div
                      class="
                        custom-control
                        custom-switch
                        custom-switch-text
                        custom-control-inline
                        custom-switch-color
                        mr-4
                      "
                    >
                      <div class="custom-switch-inner">
                        <p class="mb-0">Shared</p>
                        <input
                          type="checkbox"
                          class="custom-control-input bg-warning"
                          :id="'customSwitch-11'"
                          v-model="formValues.shared"
                        />
                        <label
                          class="custom-control-label custom-control-label-big"
                          :for="'customSwitch-11'"
                        ></label>
                      </div>
                    </div>
                    
                  <b-button
                    size="lg"
                    variant="success"
                    class="mb-3 mr-1"
                    :disabled="!changed"
                    @click="submitHandler"
                  >
                    <i class="fas fa-save mr-2"></i>SAVE
                  </b-button>
                </div>
              </b-col>
            </FormulateForm>
          </b-row>
        </iq-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div ref="emailEditor" id="emailEditor" class="editor-container"></div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { core } from "../../config/pluginInit";
const sample = require("./sample.json");
import { getAccountSync } from "../../Utils/account";
import gql from "graphql-tag";
import { base64ToUtf8 } from '../../ai-assistant';

function getCurrentTimestamp() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}`;
}

function getTemplateData(){
  const params = new URLSearchParams(window.location.search);
  const editorDataId = params.get('editorDataId');

  if (editorDataId) {
    const base64Tpl = localStorage.getItem(editorDataId);
    localStorage.removeItem(editorDataId);
    const decoded = base64ToUtf8(base64Tpl);
    const parsed = JSON.parse(decoded);
    return parsed
  }

  return sample;
}

const CREATE_TEMPLATE = gql`
  mutation createTemplate(
    $name: String!
    $editorData: jsonb!
    $html: String!
    $text: String!
    $shared: Boolean!
  ) {
    insert_templates_one(
      object: {
        name: $name
        editor_data: $editorData
        html: $html
        text: $text
        shared: $shared
      }
    ) {
      id
      name
      editor_data
      html
      text
      shared
    }
  }
`;

const GET_TEMPLATE = gql`
  query getTemplate($id: uuid!) {
    templates_by_pk(id: $id) {
      id
      editor_data
      shared
    }
  }
`;
export default {
  name: "TemplatesCreate",
  data() {
    return {
      formValues: {
        name: "New template " + getCurrentTimestamp(),
        shared: false,
      },
      changed: false,
      editor: null,
      account: getAccountSync()
    };
  },
  mounted() {
    core.index();
    this.initEditor();
    window.onbeforeunload = () => {
      if (this.changed) {
        return window.confirm("Confirm refresh");
      }
    };
  },
  methods: {
    async initEditor() {
      let templateData = getTemplateData();

      // if duplicate, load template data
      const fromTemplate = this.$route.query.fromTemplate;
      if (fromTemplate) {
        templateData = await this.getTemplate(fromTemplate);
      }

      // prepare merge tags
      const mergeTags = this.account?.mergeTags;

      // import unlayer embed.js and init editor
      const unlayerScript = document.createElement("script");
      unlayerScript.setAttribute("src", "https://editor.unlayer.com/embed.js");
      unlayerScript.onload = () => {
        const editor = window.unlayer.createEditor({
          id: "emailEditor",
          projectId: 239214,
          displayMode: "email",
          locale: "cs-CZ",
          mergeTags
        });
        editor.loadDesign(templateData);
        editor.addEventListener("design:updated", () => (this.changed = true));
        this.editor = editor;
      };
      document.head.appendChild(unlayerScript);
    },
    async submitHandler() {
      const getHtmlData = function(t) {
        return new Promise(function(resolve, reject) {
          t.editor.exportHtml(design => {
            resolve(design);
          });
        });
      };
      const getPlainTextData = function(t) {
        return new Promise(function(resolve, reject) {
          t.editor.exportPlainText(design => {
            resolve(design);
          });
        });
      };
      const htmlData = await getHtmlData(this);
      const plainTextData = await getPlainTextData(this);
      const name = this.formValues.name;
      const editorData = htmlData.design;
      const html = htmlData.html;
      const text = plainTextData.text;
      const shared = this.formValues.shared || false;
      try {
        const saveResponse = await this.$apollo.mutate({
          mutation: CREATE_TEMPLATE,
          variables: {
            name,
            editorData,
            html,
            text,
            shared,
          }
        });
        this.$toast.success(`Template created`);
        this.$formulate.reset("createTemplate");
        this.$router.push(
          `/templates/${saveResponse.data.insert_templates_one.id}/edit`
        );
      } catch (error) {
        this.$toast.error(`Failed to create template: ${error.message}`);
      }
    },
    async getTemplate(id) {
      const res = await this.$apollo.query({
        query: GET_TEMPLATE,
        variables: {
          id
        }
      });
      return res.data.templates_by_pk.editor_data;
    }
  }
};
</script>

<style scoped>
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
}
#app,
#example {
  height: 80vh;
}
#app {
  border-radius: 15px;
  overflow: hidden;
}
#example .container {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
}
#bar {
  flex: 1;
  /* background-color: #40b883; */
  background: linear-gradient(
    to right,
    var(--iq-primary) 0%,
    var(--iq-primary-light) 100%
  );
  color: #fff;
  padding: 10px;
  display: flex;
  /* max-height: 40px; */
}
#bar h1 {
  flex: 1;
  font-size: 16px;
  text-align: left;
}
#bar button {
  flex: 1;
  padding: 10px;
  margin-left: 10px;
  font-size: 14px;
  font-weight: bold;
  background-color: #000;
  color: #fff;
  border: 0px;
  max-width: 150px;
  cursor: pointer;
}
#editor-1 {
  height: 100% !important;
}
.editor-container {
  width: 100%;
  height: 700px;
  background-color: white;
  border-radius: 10px;
  overflow: hidden;
}
</style>
